import React from "react";
import { Img } from "../../Img";
import { Container, ContainerFW } from "../../global";
import { ButtonWrapper } from "./ButtonWrapper/ButtonWrapper";
import { Breadcrumbs } from "../../Breadcrumbs";
import { classNames, conditionallyCreateStyleObj, getContainerClassPerMaxWidth, } from "../../../utils";
import { HeadingFactoryWithHTMLContent } from "../../../widgets";
import { useScopedStyles } from "../../../hooks";
const getBackgroundColor = (backgroundColor = "#fff") => {
    if (backgroundColor?.startsWith("#")) {
        return backgroundColor;
    }
    return backgroundColor === "dark" ? "#0E1D31" : "#fff";
};
const checkHasComponentButton = ({ buttonHref, buttonLabel, linkHref, linkLabel, }) => (buttonHref && buttonLabel) || (linkHref && linkLabel);
const getColumnLayoutClassName = (numColumnsLargeView) => {
    const hasMaxColumnsClass = numColumnsLargeView?.startsWith("max-");
    if (hasMaxColumnsClass) {
        return ` tradeWithComponentBlackBackground--num-columns--large-view--${numColumnsLargeView}`;
    }
    return "";
};
const getClassName = (intrinsicImgSize = false, evenSetsForm2ColsMobile = false, numItems, numColumnsLargeView, cardBorderColor, backgroundColor) => {
    let className = backgroundColor === "dark"
        ? "tradeWithComponentBlackBackground-dark"
        : "tradeWithComponentBlackBackground";
    if (intrinsicImgSize) {
        className += " tradeWithComponentBlackBackground--intrinsic-img-size";
    }
    if (evenSetsForm2ColsMobile && numItems % 2 === 0) {
        className += " tradeWithComponentBlackBackground--two-cols-mobile";
    }
    if (cardBorderColor) {
        className += " tradeWithComponentBlackBackground--bordered-cards";
    }
    const columnLayoutClass = getColumnLayoutClassName(numColumnsLargeView);
    return `${className} ${columnLayoutClass}`;
};
const getTitle = (title, h2Title) => {
    if (title) {
        return !h2Title ? (React.createElement("h1", { className: "tradeWithComponent-mainTitle", dangerouslySetInnerHTML: { __html: title } })) : (React.createElement("h2", { className: "tradeWithComponent-mainTitle", dangerouslySetInnerHTML: { __html: title } }));
    }
    else {
        return "";
    }
};
const getContainerExtraClass = (containerMaxWidth) => {
    const containerMaxWidthClass = containerMaxWidth && getContainerClassPerMaxWidth(containerMaxWidth);
    return containerMaxWidthClass ? ` ${containerMaxWidthClass}` : "";
};
export const TradeWithComponentBlackBackground = ({ mainTitle, h2title, subMainTitle, sectionItems, buttonHref, buttonLabel, linkLabel, linkHref, backgroundColor, breadcrumbs, openInNewTabButton, linkOpenInNewTab, containerMaxWidth, subTitleColor, subTitlePosition, subTitleFontWeight, titleColor, titlePosition, titleFontWeight, intrinsicImgSize = false, evenSetsForm2ColsMobile = false, mainTitleWidth, cardContentAlignment, numColumnsLargeView = "items-count", cardBorderColor, cardCustomCSS, }) => {
    const cssScopeId = useScopedStyles(cardCustomCSS);
    const correctedBgColor = getBackgroundColor(backgroundColor);
    const hasButton = checkHasComponentButton({
        buttonHref,
        buttonLabel,
        linkHref,
        linkLabel,
    });
    const className = getClassName(intrinsicImgSize, evenSetsForm2ColsMobile, sectionItems.length, numColumnsLargeView, cardBorderColor, backgroundColor);
    const wrapperClass = sectionItems.length <= 3
        ? "tradeWithComponent-sectionWrapper"
        : "tradeWithComponent-sectionWrapper--larger";
    const containerExtraClass = getContainerExtraClass(containerMaxWidth);
    const getCustomStyleObj = () => conditionallyCreateStyleObj({
        "--title-color": titleColor,
        "--title-position": titlePosition,
        "--title-font-weight": titleFontWeight,
        "--subtitle-color": subTitleColor,
        "--subtitle-position": subTitlePosition,
        "--subtitle-font-weight": subTitleFontWeight,
        "--main-title-width": mainTitleWidth,
        "--card-content-alignment_small-view": cardContentAlignment?.["small-view"],
        "--card-content-alignment_medium-view": cardContentAlignment?.["medium-view"],
        "--card-content-alignment_large-view": cardContentAlignment?.["large-view"],
        "--card-border-color": cardBorderColor,
    });
    const customStyleObj = getCustomStyleObj();
    const getCustomCardStyleObj = (bgColor) => conditionallyCreateStyleObj({
        "--card-background-color": bgColor,
    });
    return (React.createElement(ContainerFW, { backgroundColor: correctedBgColor, className: containerExtraClass },
        React.createElement("div", { className: className, style: customStyleObj, id: cssScopeId },
            breadcrumbs && (React.createElement("div", { className: "breadcrumbs__container" },
                React.createElement(Breadcrumbs, { breadcrumbs: breadcrumbs }))),
            React.createElement(Container, { className: containerExtraClass },
                getTitle(mainTitle, h2title),
                subMainTitle && (React.createElement("div", { className: "tradeWithComponent-subTitle", dangerouslySetInnerHTML: {
                        __html: subMainTitle,
                    } })),
                React.createElement("div", { className: wrapperClass }, sectionItems.length > 0 &&
                    sectionItems?.map((a, i) => (React.createElement("div", { key: i, className: classNames("tradeWithComponent-sectionWrapper__section", {
                            "tradeWithComponent-sectionWrapper__section--has-padding": !!a.backgroundColor,
                        }), style: getCustomCardStyleObj(a.backgroundColor) },
                        React.createElement(Img, { src: a.imageUrl, className: "tradeWithComponent-sectionWrapper__section__image", alt: a.imageAlt }),
                        React.createElement(HeadingFactoryWithHTMLContent, { headingDesign: "h4-semi-bold", headingContent: a.title }),
                        a.subTitle && (React.createElement("div", { className: "tradeWithComponent-sectionWrapper__section__subTitle", dangerouslySetInnerHTML: {
                                __html: a.subTitle,
                            } })))))),
                hasButton && (React.createElement(ButtonWrapper, { buttonHref: buttonHref, buttonLabel: buttonLabel, linkHref: linkHref, linkLabel: linkLabel, openInNewTabButton: openInNewTabButton, linkOpenInNewTab: linkOpenInNewTab }))))));
};
